import { Button, makeStyles } from "@material-ui/core";
import AddAPhotoOutlined from "@material-ui/icons/AddAPhotoOutlined";
import reportLitterImage from "assets/images/record/report-litter.webp";

import styles from "standard.module.scss";
import { usePhotoPageDispatch, resetState } from "pages/photo/state";
import useEffectOnMount from "hooks/useEffectOnMount";
import { Trans } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box"
  },
  imageContainer: {
    flex: 1,
    minHeight: 0,
    display: "flex"
  },
  image: {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  content: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2)
  },
  text: {
    textAlign: "center",
    textWrap: "pretty"
  },
  button: {
    flex: 1,
    width: "100%",
    height: "100%",
    padding: 0,
    minWidth: 0,
    borderRadius: 0,
    background: "transparent",
    "&:focus": { background: styles.lightGrey },
    "&:hover": { background: "transparent" }
  },
  buttonLabel: {
    width: "100%",
    height: "100%",
    display: "flex"
  },
  link: {
    color: theme.palette.primary.main
  }
}));

type Props = {
  onPhotoClick: () => void;
  linkToTutorialPage: () => string | Object;
};
export default function NewPhotoPage({
  onPhotoClick,
  linkToTutorialPage
}: Props) {
  const styles = useStyles();
  const dispatch = usePhotoPageDispatch();
  useEffectOnMount(() => {
    dispatch(resetState());
  });

  return (
    <>
      <div className={styles.wrapper}>
        <Button
          className={styles.imageContainer}
          classes={{ root: styles.button, label: styles.buttonLabel }}
          disableRipple
          onClick={onPhotoClick}
          disableElevation
        >
          <img
            src={reportLitterImage}
            alt="Report litter"
            className={styles.image}
          />
        </Button>
        <div className={styles.content}>
          <div className={styles.text}>
            <Trans i18nKey="record_litter_description">
              <p>Make sure the litter items are clearly visible.</p>
            </Trans>
          </div>
          <Button
            variant="outlined"
            color="primary"
            disableElevation
            onClick={onPhotoClick}
            startIcon={<AddAPhotoOutlined />}
            size="large"
          >
            Add Photo
          </Button>
        </div>
      </div>
    </>
  );
}
